export default __webpack_public_path__ + "static/media/feature-item-leaderboard.2226fd98.svg";